/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-06 20:23:25
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-06-28 15:43:19
 */

import request from "../../utils/request";
import server from "./config";
const uploadUrl = `${server.MS_PATIENT_CONSUMMER}/file/1/upload`;
export default {
    uploadUrl,
    /**
     * 上传数据
     */
    upload: (file, noToast = false) => {
        var formData = new FormData();
        formData.append("file", file);
        return request({
            url: uploadUrl,
            method: "post",
            data: formData,
            noToast
        });
    },
    /**
     * 获取省市区
     */
    getSysRegionTree: params => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/sysregion/1/getSysRegionTree`,
            method: "get",
            params
        });
    },
    /**
     * 获取省市区-JD
     */
     getSysRegionTreeByJd: params => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/sysregion/1/getSysRegionJd`,
            method: "post",
            params
        });
    },
    /**
     * 获取科室
     */
    getDepartmentList: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/dictionary/1/showList`,
            method: "post",
            data
        });
    },
    // 医院
    hospitalList: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/1/hospital/getPageList`,
            method: "post",
            data
        });
    },
    /**
     * 获取职称
     */
    showDoctorTitle: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/dictionary/1/showDoctorTitle`,
            method: "post",
            data
        });
    },
    /**
     * 获取药店详情
     */
    showMerchantById: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/merchant/{version}/showMerchantById`,
            method: "post",
            data
        });
    },
    /**
     * 热线
     */
    rexian: data => {
        return request({
            url: `${process.env.RX_URL}/cpnt/beCurrent/getHotWire?pj_code=3&pt_code=0`,
            method: "get",
            data:{}
        }); 
    },
    /**
     * 备案科室
     */
    depts: data => {
        return request({
            url: `${process.env.RX_URL}/cpnt/depart/all?isFillings=1&pj_code=3&pt_code=2&ts=1&sign=1`,
            method: "get",
            data:{}
        }); 
    },
    /**
     * 投诉
     */
    feedbackList: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/complaint/1/patient/get`,
            method: "post",
            data
        });
    },
    feedbackAdd: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/complaint/1/patient/create`,
            method: "post",
            data
        });
    },
    feedbackLogs: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/complaint/1/patient/logs/get`,
            method: "post",
            data
        });
    },
    //系统设置
    getConfigByKey: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/sys/config/{version}/getConfigByKey?configKey=${data.configKey}`,
            method: "post"
        });
    },
   //校验代表手机号
   checkIsSysUserAddress: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/address/1/checkIsSysUserAddress?phone=${data}`,
            method: "post",
            noToast:true,
        });
    },
    //评价
    addComment: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/comment/platform/1/add`,
            method: "post",
            data
        });
    },
    //校验患者是否评价
    getPatientCommentCount: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/comment/platform/1/getPatientCommentCount?patientMemberId=${data.patientMemberId}`,
            method: "post",
            data
        });
    },
    // 获取项目下配置的病种
    diseaseType: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/yzj/1/disease/type`,
            method: "get",
            data:{}
        }); 
    },
    //获取上传文件配置
    getUpLoadConfig(data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/sys/config/1/getUpLoadConfig`,
            method: 'post',
            data
        })
    } 
};




// WEBPACK FOOTER //
// ./src/api/modules/sys.js